/*
 * CUSTOM (Schuhbeck): Physical Store section — consent-gated Google Maps.
 * The section renders a placeholder (merchant-uploaded blurred screenshot)
 * and this element only injects the maps.google.com iframe after the
 * visitor clicks "Karte laden" (GDPR: no request to Google before that).
 * The choice is remembered for the browsing session, so further instances
 * or page views load the map immediately.
 */
(() => {
  if (customElements.get('physical-store-map')) return;

  const CONSENT_KEY = 'physical-store-map-consent';

  const hasConsent = () => {
    try {
      return window.sessionStorage.getItem(CONSENT_KEY) === '1';
    } catch (e) {
      return false;
    }
  };

  const storeConsent = () => {
    try {
      window.sessionStorage.setItem(CONSENT_KEY, '1');
    } catch (e) {
      /* private mode — map still loads, choice just isn't remembered */
    }
  };

  class PhysicalStoreMap extends HTMLElement {
    connectedCallback() {
      if (hasConsent()) {
        this.loadMap();
        return;
      }
      const button = this.querySelector('.physical-store__map-load');
      if (button) {
        button.addEventListener('click', () => {
          storeConsent();
          this.loadMap();
        });
      }
    }

    loadMap() {
      if (this.querySelector('iframe')) return;
      const query = this.dataset.mapQuery || '';
      if (!query) return;
      const iframe = document.createElement('iframe');
      iframe.src = 'https://maps.google.com/maps?q=' + encodeURIComponent(query) + '&z=16&output=embed';
      iframe.loading = 'lazy';
      iframe.title = this.dataset.mapTitle || '';
      iframe.referrerPolicy = 'no-referrer-when-downgrade';
      this.appendChild(iframe);
      const placeholder = this.querySelector('.physical-store__map-placeholder');
      if (placeholder) placeholder.remove();
    }
  }

  customElements.define('physical-store-map', PhysicalStoreMap);
})();
